import React from 'react';
import { TAttribute } from '../model';
import Radio from 'Components/DesignSystem/Radio/Radio';

type AttributeListItemProps = {
  item: TAttribute;
  isSelected: boolean;
  onToggle: (id: string) => void;
  disabled?: boolean;
};

/**
 * One selectable attribute in the Product Attribute Import dialog.
 *
 * Was an unstyled native radio — the browser's blue, not the design system's accent —
 * inside a `<div role="button" onClick>`, with `onChange={() => {}}` on the input
 * itself. That last part mattered: the radio was focusable, so arrow keys moved
 * through the group, but the no-op `onChange` meant the controlled `checked` snapped
 * straight back. **The list looked keyboard-operable and was not.**
 *
 * `name` is kept as the existing `attributeRadio` so the grouping is byte-identical;
 * only one dialog mounts this at a time.
 */
const AttributeListItemRB = ({ item, isSelected, onToggle, disabled }: AttributeListItemProps) => (
  <Radio
    data-testid="components-attributelistitemrb-input-1"
    name="attributeRadio"
    value={item?.id ?? ''}
    label={item?.name ?? ''}
    checked={isSelected}
    disabled={disabled}
    /* The guard lived on the wrapper div (`!disabled && onToggle(...)`). Kept
       explicitly rather than relying on the `disabled` attribute alone: React wires
       radio/checkbox `onChange` to the CLICK event, so a programmatic click still
       reaches the handler even when the input is disabled. */
    onChange={() => { if (!disabled) onToggle(item.id); }}
    className="tw-mb-2"
  />
);

export default AttributeListItemRB;
